<template>
  <div>
    <ChatRecipientSelector
        @recipient-selected="handleRecipientSelected"
        :loading="loadingRecipientSelector"
        :showSelectors="showSelectors"
        :recipients="recipients"
    />
    <Chat
        v-if="canChat == true"
        :queue="messages"
        :hasNewMessage="hasNewMessage"
        :allowEmojis="false"
        :participant="participants[0]"
        :allowFiles="false"
        :showChatBoard="isChatOpen"
        :senderIdValue="userId"
        :onMessageSend="sendMessage"
        :showChatIcon="showChatIcon"
        @chat-header-click="handleChatHeaderClick"
        @chat-scrolled="chatHasScrolled()"
        @onInputChanged="onInputChanged"
        @chat-bubble-click="handleChatBubbleClick"
    ></Chat>
    <!-- :onlineStatus="chat.onlineStatus" -->
    <!-- :connected="chat.connected" -->
  </div>
</template>

<script>
/* eslint-disable */
import ChatRecipientSelector from "@/components/chat/ChatRecipientSelector";
import Chat from "@/components/chat/Chat";
import BaseHelper from "../../helpers/BaseHelper";
import { Store } from "../../Store";
import WebSocketClient from "../../plugins/WebSocketClient";
import { ChatClient } from "../../clients/ChatClient";
import { UserClient } from "../../clients/UserClient";
import Vue from "vue";
import VueSocketIO from "vue-socket.io";
import { WEBSOCKET_HOST, WEBSOCKET_PORT } from "../../Variables";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
export default {
  components: {
    Chat,
    ChatRecipientSelector,
  },
  name: "MentorChat",
  mixins: [BaseHelper],

  data() {
    return {
      newMessagesCount: 0,
      hasNewMessage: false,
      userId: this.$store.state.auth.user.id,
      programLeads: [],
      canChat: false,
      loadingRecipientSelector: false,
      recipientSelected: false,
      showSelectors: false,
    };
  },
  watch: {
    chats() {
      Echo.join(`Chat.${this.activeChat.id}`)
          .here((users) => {
            //                            //
            //                            console.log('here');
            //                            console.log(users);
          })
          .joining((user) => {
            //                            console.log('joining');
            //                            console.log(user.first_name);
          })
          .leaving((user) => {
            //                            console.log('leaving');
            //                            console.log(user.first_name);
          })
          .listen(".Modules\\Chat\\Events\\ChatMessageCreated", (message) => {
            console.log(message)
            this.$store.dispatch("chat/setNewMessage", message);
            this.hasNewMessage = true;
            //store which chat has new message
            //store how many messages that chat has
            //temp have user id of chat for highlighting
          });
    },
  },
  computed: {
    showChatIcon() {
      return !(this.showSelectors == true || this.isChatOpen == true);
    },
    recipients() {
      let arrayValue = [];
      if (this.processedProgramLeads.length > 0) {
        arrayValue.push({
          type: "Program Lead",
          users: this.processedProgramLeads,
        });
      }
      if (this.mentors.length > 0) {
        arrayValue.push({
          type: "Mentor",
          users: this.mentors,
        });
      }
      return arrayValue;
    },
    processedProgramLeads() {
      if (this.programLeads.length > 0) {
        return this.programLeads.map((user) => ({
          id: user.id,
          attributes: {
            first_name: user.first_name,
            last_name: user.last_name,
            profile_url: user.profile_url,
          },
        }));
      }
      return this.programLeads;
    },
    ...mapState("mentor", {
      mentors: (state) => state.mentors,
    }),
    ...mapState("chat", {
      isChatOpen: (state) => state.isChatOpen,
      participants: (state) => state.participants,
      activeChatIndex: (state) => state.activeChatIndex,
      chat: (state) => state.chat,
      chats: (state) => state.chats,
      messages(state) {
        if (this.activeChat !== null) {
          if (this.activeChat.attributes.hasOwnProperty("messages")) {
            return this.activeChat.attributes.messages.map((message) => ({
              author:
                  this.$store.state.auth.user.id == message.attributes.from_id
                      ? "me"
                      : message.attributes.from_id,
              type: "text",
              id: 1, // or text '1'
              isEdited: false,
              text: message.attributes.message,
              data: {
                text: message.attributes.message,
                meta: message.attributes.created_at,
              },
            }));
          }
        }

        return [];
      },
    }),
    ...mapGetters("chat", {
      titleImageUrl: "guestUserImage",
      activeChat: "activeChat",
    }),
  },
  methods: {
    handleChatBubbleClick() {
      if (this.isChatOpen && this.recipientSelected) {
        this.$store.dispatch("chat/closeChat");
        this.showSelectors = false;
        return;
      }
      if (this.isChatOpen && !this.recipientSelected) {
        this.$store.dispatch("chat/closeChat");
        this.showSelectors = true;
        return;
      }
      if (!this.isChatOpen && !this.recipientSelected) {
        this.$store.dispatch("chat/closeChat");
        this.showSelectors = !this.showSelectors;
        return;
      }
      if (!this.isChatOpen && this.recipientSelected) {
        this.$store.dispatch("chat/showChat");
        return;
      }
    },
    handleChatHeaderClick() {
      this.recipientSelected = false;
      this.showSelectors = true;
      this.$store.dispatch("chat/closeChat");
    },
    sendMessage(message) {
      if (message.length > 0) {
        //                    this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
        //                    this.onMessageWasSent({author: 'support', type: 'text', data: {text}})
        return this.$store.dispatch("chat/sendMessage", message);
      }
    },
    handleRecipientSelected(recipient) {
      this.loadingRecipientSelector = true;
      let participant = {
        id: recipient.id,
        name:
            recipient.attributes.first_name +
            " " +
            recipient.attributes.last_name,
        imageUrl: recipient.attributes.profile_url,
      };
      this.$store.dispatch("chat/setParticipants", [participant]);
      this.$store.dispatch("chat/getPrivateChat", participant.id).then(() => {
        this.recipientSelected = true;
        this.loadingRecipientSelector = false;
        this.$nextTick(() => {
          this.$store.dispatch("chat/showChat");
          this.$store.dispatch("chat/clearNew");
        });
      });
    },
    onInputChanged(file) {
      this.chat.message.file = file;
    },

    chatHasScrolled() {
      this.hasNewMessage = false;
      this.$store.dispatch("chat/clearNew", this.activeChatIndex);
    },
  },

  mounted() {
    this.canChat = true;
    this.$store.dispatch("mentor/fetch");

    UserClient.getProgramLeads()
        .then((result) => {
          this.programLeads = result.data.data;
        })
        .catch((err) => {});
  },
};
</script>